<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
     <div class="save-panel">
      <button class="btn btn-sm btn-success btn-icon mt-4" @click="updateItem">
        <span class="ti-save"></span>Сохранить
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

import FieldsList from "../FieldsList";

export default {
  props: ["product"],
  data: () => ({
    cardSetLink: "products/modifications",
    item: {},
    fields: [
      {
        col: " col-12",
        key: "is_active",
        label: "Активность",
        type: "checkbox",
        textType: "text",
      },
      {
        col: "col-md-6 col-12",
        key: "labels",
        selectKey: "title",
        label: "Тэги",
        type: "selects",
        modal: "label",
      },
      {
        col: "col-md-6 col-12",
        label: "Цвет",
        key: "color",
        type: "select",
        selectKey: "title",
        modal: "color",
      },
      {
        col: "col-md-6 col-12",
        key: "name",
        label: "Название модели (уникальность)",
        type: "field",
        textType: "text",
      },
      {
        col: "col-md-6 col-12",
        key: "sku",
        label: "Баркод",
        type: "field",
        textType: "text",
      },
      {
        col: "col-md-4 col-12",
        key: "price",
        label: "Цена",
        type: "field",
        textType: "number",
      },
      {
        col: "col-md-4 col-12",
        key: "cashback_percent",
        label: "Процент кешбека (%)",
        type: "field",
        textType: "number",
      },
      {
        col: "col-md-4 col-12",
        key: "price_old",
        label: "Старая цена",
        type: "field",
        textType: "number",
      },
      {
        col: "col-md-4 col-12",
        key: "quantity",
        label: "Количество",
        type: "field",
        textType: "number",
      },
      {
        key: "title",
        label: "Доп название",
        type: "field",
        textType: "text",
        isMultiLang: true,
      },
      {
        key: "annotation",
        label: "Краткое описание",
        type: "textarea",
        isMultiLang: true,
      },
      {
        key: "body",
        label: "Полное описание",
        type: "html",
        isMultiLang: true,
      },
    ],
  }),
  components: {
    FieldsList,
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,

    async updateItem() {
      this.item["product"] = this.product;
      let item = await this.cardUpdate(this.cardSetLink, this.item);
      if (item && item.id) {
        this.$emit("create", item.id);
      }
      //console.log(item);
    },
  },
};
</script>
<style>
</style>
